import type { LocalPhoto } from '../../lib/types';

const MAX_THUMBS = 5;

/**
 * Overlapping thumbnail stack (54×40, 2px white borders, −38px overlap,
 * max 5 + "+N"). `framed` renders each thumb inside a mini black frame.
 */
export function ThumbStack({
  photoIds,
  photosById,
  framed,
}: {
  photoIds: readonly string[];
  photosById: ReadonlyMap<string, LocalPhoto>;
  framed?: boolean;
}) {
  const shown = photoIds.slice(0, MAX_THUMBS);
  const extra = photoIds.length - shown.length;
  return (
    <div className={`tstack${framed ? ' tstack--framed' : ''}`} aria-hidden="true">
      {shown.map((id, i) => {
        const url = photosById.get(id)?.previewUrl ?? null;
        return (
          <span key={id} className="tstack__thumb" style={i > 0 ? undefined : { marginLeft: 0 }}>
            {url ? <img src={url} alt="" loading="lazy" /> : <span className="tstack__ph" />}
          </span>
        );
      })}
      {extra > 0 && <span className="tstack__thumb tstack__more">+{extra}</span>}
    </div>
  );
}
